export default __webpack_public_path__ + "static/logos-127303e6f23f2dd788060f4260e13fd0.jpg";